module.exports = __webpack_public_path__ + "img/DSC_2646-xs.135db6d1.png";